module.exports = __webpack_public_path__ + "img/bezier-curve-02.5d38a7d6.svg";